import Footer from "./Cult_Footer/Footer";

export const CultFooter = () => {
  return (
    <>
      <Footer></Footer>
    </>
  );
};

export default CultFooter;
